export const REMOVE_BG_HEADER_SEGMENTS = [
  {
    label: 'AI Background',
    value: 'ai_background',
    testId: 'remove-bg-ai-background-tab',
    badge: 'new',
  },
  {
    label: 'Simple',
    value: 'simple',
    testId: 'remove-bg-simple-tab',
  },
];

export const CREATE_BG_HEADER_SEGMENTS = [
  {
    label: 'Upload inspo',
    value: 'upload_inspo',
    testId: 'remove-bg-upload-inspo-tab',
  },
  {
    label: 'Manual',
    value: 'manual',
    testId: 'remove-bg-manual-background-tab',
  },
];

export const BACKGROUNDS_TITLE = 'Background';
export const REMOVE_BG_SUBTITLE = 'Choose a background for your photos';
export const CUSTOM_BG_TITLE = 'My backgrounds';
export const CENTER_OBJ_TITLE = 'Align object to center';

export const INPAINTING_MODEL_BODY = {
  remove_extra_spaces: true,
  paint_mask: false,
  task_type: 'smartbg-v2-acc-batch',
  guidance_scale: 1,
  sampling_steps: 20,
  mask_blur: 0,
  padding_mask_fill_value: 255,
  padding_multiplier: 512,
  inpaint_area: 'whole_picture',
  inpaint_mask_padding: 32,
  sampling_method: 'DDIM_trailing',
  masked_content: 'latent_noise',
  denoising_strength: 1.0,
  blending_config: { blending_type: 'alpha_blend', blending_params: { dilation: 5, blur: 5 } },
  blend: true,
};

export const INPAINTING_MODEL_NEGATIVE_PROMPT =
  'text, watermark, written words, letters, bad anatomy, bad proportions, blurry, cloned face, cropped, deformed, dehydrated, disfigured, duplicate, error, extra arms, extra fingers, extra legs, extra limbs, fused fingers, gross proportions, jpeg artifacts, long neck, low quality, lowres, malformed limbs, missing arms, missing legs, morbid, mutated hands, mutation, mutilated, out of frame, poorly drawn face, poorly drawn hands, signature, text, too many fingers, ugly, username, watermark, worst quality';
